export default __webpack_public_path__ + "4b473e1335c17051763bc04f4c1a65d3.jpg";